import { render, staticRenderFns } from "./GeneralSettingsDateFormatBackend.vue?vue&type=template&id=4acf2549&"
import script from "./GeneralSettingsDateFormatBackend.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsDateFormatBackend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports